export enum EImportType {
  File,
  Template,
  GoogleDrive,
  GoogleDocs,
  WordDocument,
}
